class ProfetFAQ {
	constructor() {}
	init() {
		let faqItems = document.querySelectorAll('[data-toggle-faq]');
		if (!faqItems.length) {
			return;
		}
		faqItems.forEach((item) => {
			item.addEventListener('click', function(event) {
				event.preventDefault();
				let target = document.querySelector(item.getAttribute('data-toggle-faq'));
				if (target) {
					target.classList.toggle('active');
					let answer = target.querySelector('.faq-answer');
					if (answer) {
						answer.classList.toggle('active');
					}
				}
			});
		});
	}
}
window.addEventListener('load', () => {
	window.ProfetFAQ = new ProfetFAQ();
	window.ProfetFAQ.init();
});

window.addEventListener('load', () => {});
